import React from "react";
import { IoCloseCircleOutline } from "react-icons/io5";

const CloseCircle = ({ onclose, marModal}) => {
  return (
    <IoCloseCircleOutline
      size={40}
      id="close-circle"
      style={{
        position: "absolute",
        right:  marModal ? "0px" : "-18px",
        top: marModal ? "0px" : "-18px",
        cursor: "pointer",
        zIndex: 9999,
      }}
      onClick={onclose}
    />
  );
};

export default CloseCircle;
